export const N10_01 = {
  selectedValueColumn: "AgentCode",
  selectedTitle: "Account",
  visual: [
    {
      columns: 12,
      rows: 2,
      visual: {
        id: 1,
        type: "advancedTable",
        colorTheme: "colorTheme1",
        title: "Accounts",
        binding: {
          data: {
            columns: [
              //  {
              //   name: "Account Code",
              //   columnName: "AccountCode",
              //   width: "180px",
              //   align: "left",
              //   sortable: true
              // },
              {
                name: "Account Name",
                columnName: "AccountName",
                width: "450px",
                align: "left",
                sortable: true,
              },
              // {
              //   name: "Channel Code",
              //   columnName: "ChannelCode",
              //   width: "180px",
              //   align: "left",
              //   sortable: true,
              // },
              {
                name: "Channel",
                columnName: "Channel",
                width: "230px",
                align: "left",
                sortable: true,
              },
              // {
              //   name: "Specialization Code",
              //   columnName: "SpecializationCode",
              //   width: "220px",
              //   align: "left",
              //   sortable: true,
              // },
              {
                name: "Specialization",
                columnName: "Specialization",
                width: "230px",
                align: "left",
                sortable: true,
              },
              // {
              //   name: "Class Code",
              //   columnName: "ClassCode",
              //   width: "180px",
              //   align: "left",
              //   sortable: true,
              // },
              {
                name: "Classification",
                columnName: "Classification",
                width: "230px",
                align: "left",
                sortable: true,
              },
              // {
              //   name: "Maximum Visit",
              //   columnName: "MaximumVisit",
              //   width: "180px",
              //   align: "center",
              //   sortable: true,
              // },
              {
                name: "Planned",
                columnName: "Planned",
                width: "180px",
                align: "center",
                sortable: true,
              },
              // {
              //   name: "Target",
              //   columnName: "Target",
              //   width: "180px",
              //   align: "center",
              //   sortable: true,
              // },
              {
                name: "WK1",
                columnName: "wk1",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "WK2",
                columnName: "wk2",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "WK3",
                columnName: "wk3",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "WK4",
                columnName: "wk4",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "WK5",
                columnName: "wk5",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Missed Call",
                columnName: "MissedCall",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Recovery Call",
                columnName: "RecoveryCall",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Advance Call",
                columnName: "AdvanceCall",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Total Calls",
                columnName: "TotalCalls",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Frequency",
                columnName: "Frequency",
                width: "180px",
                align: "center",
                sortable: true,
              },
              {
                name: "Reach",
                columnName: "Reach",
                width: "180px",
                align: "center",
                sortable: true,
              },
            ],
            title: "AgentCode",
            endpoint: "SFE_N10.1",
            parameters: [
              { key: "CycleCode", value: "CP1" },
              { key: "CycleYear", value: "2026" },
              { key: "AgentCode", value: "" },
            ],
          },
          context: {
            point: {
              onClick: {},
            },
          },
        },
      },
    },
  ],
};